import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { RateCodeSearchState, parseBooleanFilter } from '~/components/Cruises/components/shared/RateCodeGridConfig';

import rateCodeService from '~/services/cruises/RateCodeService';

import { rateCodeQueryKeys } from './rateCodeQueryKeys';

export const RATE_CODE_PAGE_SIZE = 100;

export function useGetRateCodes(vendorCode: string | undefined, search: RateCodeSearchState, page: number) {
  return useQuery({
    queryKey: rateCodeQueryKeys.list(vendorCode, search, page),
    queryFn: () =>
      rateCodeService.getRateCodeList({
        skip: page * RATE_CODE_PAGE_SIZE,
        take: RATE_CODE_PAGE_SIZE,
        vendorCode,
        rateCodes: search.rateCode || undefined,
        isFlash: parseBooleanFilter(search.isFlash),
        isNetRate: parseBooleanFilter(search.isNetRate),
      }),
    enabled: !!vendorCode,
    placeholderData: keepPreviousData,
  });
}
